import { render, staticRenderFns } from "./SetLinksForClientsDialog.vue?vue&type=template&id=f4fc1eac"
import script from "./SetLinksForClientsDialog.vue?vue&type=script&lang=js"
export * from "./SetLinksForClientsDialog.vue?vue&type=script&lang=js"
import style0 from "./SetLinksForClientsDialog.vue?vue&type=style&index=0&id=f4fc1eac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports